import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.66663 16.6666H18.3333V13.3333H1.66663V16.6666ZM3.33329 14.1666H4.99996V15.8333H3.33329V14.1666ZM1.66663 3.33325V6.66659H18.3333V3.33325H1.66663ZM4.99996 5.83325H3.33329V4.16659H4.99996V5.83325ZM1.66663 11.6666H18.3333V8.33325H1.66663V11.6666ZM3.33329 9.16658H4.99996V10.8333H3.33329V9.16658Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgStorage);
export default ForwardRef;
